import React, { useState, useEffect, useCallback } from "react";
import { Formik, Field } from "formik";
import { Button, Modal, Form } from "react-bootstrap";
// import SearchSelectInput from "./SelectComponents/SearchSelectInput";
import { useSubheader } from "../../_metronic/layout";

import * as UIHelpers from "./UIHelpers";
import {
  Checkbox,
  CustomeSelect,
  DateRangPickerField,
  Input,
  Input2,
  NormalInput,
  Select,
} from "../../_metronic/_partials/controls";
import SearchSelectInput from "./SelectComponents/SearchSelectInput";
import RLDD from "react-list-drag-and-drop/lib/RLDD";

import ExportDataTableButton from "./ExportDataTableButton";
import DataTableDropdown from "./DataTableDropdown";
import ColumnsFilter from "./ColumnsFilter";
import "./DateRangeFilterComponent.css";
// import '../css/style.bundle.css';

const DateRangeFilterComponent = (props) => {
  const [count, setCount] = useState(0);
  const [showColumnModal, setShowColumnModal] = useState(false);

  useEffect(() => {
    console.log("DateRangeFilterComponent");
  }, []);

  return (
    <>
      <div
        className="report-filter-bLock border-0 row align-items-center"
        style={{ padding: "0px 0", margin: "0px" }}
      >
        <Formik
          initialValues={{ dateRang: props.dateRang }}
          onSubmit={(values) => {
            // var send_values = values;
            // let type;

            // if (props?.mainDropdownFilterData) {
            //   type = props?.mainDropdownFilterData.find(
            //     (val) => val.isSelected === true
            //   );
            //   send_values.type =
            //     type === undefined || type === null ? "" : type;
            // }

            // if (props?.subDropdownFilterData) {
            //   type = props?.subDropdownFilterData.find(
            //     (val) => val.isSelected === true
            //   );
            //   send_values.subType =
            //     type === undefined || type === null ? "" : type;
            // }

            // console.log("val::22", send_values);
            // props.applyFilter(send_values);
          }}
        >
          {({ handleSubmit, handleChange, values }) => (
            <div className="col-lg-12 col-md-12 pl-0">
              <form
                // onSubmit={handleSubmit}
                className="form form-filter w-100"
                autoComplete="off"
              >
                <div className="form-group row m-0 align-items-center">
                  <>
                    {/* <div className="col-md-3">
                          <Field
                            name="game"
                            component={SearchSelectInput}
                            placeholder="Game"
                            label="Game"
                            source="games"
                          />
                        </div> */}

                    {/* <div className="isFilterApply">
                          <Field
                            name="isFilterApply"
                            component={Checkbox}
                            isSelected={props.isFilterApply}
                            label="Is Filter Apply"
                            onChange={props.isFilterApplyChange}
                          />
                        </div> */}
                  </>
                  <div
                    className="col-lg-8 col-md-7"
                    style={{
                      // maxWidth: "250px",
                      position: "relative",
                      top: "-9px",
                    }}
                  >
                    <DateRangPickerField
                      name="dateRang"
                      placeholder="Select Date Range"
                      label="Date Range"
                      dateRang={props.dateRang}
                    // Updatedrang={Updatedrang}
                    />
                  </div>
                  {/* {
                    (props.isUserFilter || props.isEmailLogFilter || props.isRetentionDropdown) 
                    && 'OR'
                  } */}

                  {props.isEmailPhoneSearchFilter && (
                    <>
                      <div
                        className="col"
                        style={{ maxWidth: "250px", top: "-9px" }}
                      >
                        <Field
                          name="phoneEmail"
                          component={Input2}
                          label="Search"
                          // validateOnBlur={false}
                          placeholder="Search"
                        //  Phone or Email
                        />
                      </div>
                      {/* <div className="col-lg-2 col-md-2">
                            <Field
                                name="email"
                                component={Input}
                                label="email"
                                placeholder="Search Email"
                            />
                        </div> */}
                    </>
                  )}
                  {props.isEmailLogFilter && (
                    <>
                      <div
                        className="col-lg-5 col-md-5"
                        style={{ position: "relative", top: "-9px" }}
                      >
                        <Select name="type" label="Content Type">
                          {UIHelpers.notifyTypeOptions.map((optionItem, i) => (
                            <option key={i} value={optionItem._id}>
                              {optionItem.name}
                            </option>
                          ))}
                        </Select>
                        {/* <CustomeSelect
                          name={"type"}
                          label={"Content Type"}
                          data={UIHelpers.notifyTypeOptions}
                          placeholder="Content Status"
                          labelKey="name"
                          valueKey="_id"
                        /> */}
                      </div>
                      {/* <div className="col-lg-2 col-md-2">
                            <Field
                                name="email"
                                component={Input}
                                label="email"
                                placeholder="Search Email"
                            />
                        </div> */}
                    </>
                  )}

                  <>
                    {/* {
                    props.isMainTypeDropdownFilter &&
                    <div className="col" style={{ maxWidth: '250px', position: 'relative', top: '-9px' }}>
                      <Select name="type" label="Type">
                        {mainTypeDropdownFilterData.map((optionItem, i) => (
                          <option className="dropdown_main" key={i} value={optionItem._id}>
                            {optionItem.name}
                          </option>
                        ))}
                      </Select>
                    </div>
                  } */}

                    {/* {
                    props.isSubTypeDropdownFilter &&
                    <div className="col" style={{ maxWidth: '250px', position: 'relative', top: '-9px' }}>
                      <Select name="subType" label="Sub Type">
                        {subTypeDropdownFilterData.map((optionItem, i) => (
                          <option key={i} value={optionItem._id}>
                            {optionItem.name}
                          </option>
                        ))}
                      </Select>
                    </div>
                  } */}
                  </>

                  {props.isMainDropdownFilter && (
                    <div
                      className="col"
                      style={{
                        maxWidth: "250px",
                        position: "relative",
                        top: "-9px",
                      }}
                    >
                      <DataTableDropdown
                        label={props?.mainDropdownFilterLabel}
                        dropdownFilterData={props?.mainDropdownFilterData}
                        onClickSetDropdownFilterData={
                          props?.onClickSetMainDropdownFilterData
                        }
                      />
                    </div>
                  )}
                  {!props.paymethloder ? (
                    props.isSubDropdownFilter && (
                      <div
                        className="col"
                        style={{
                          maxWidth: "250px",
                          position: "relative",
                          top: "-9px",
                        }}
                      >
                        <DataTableDropdown
                          label={props?.subDropdownFilterLabel}
                          dropdownFilterData={props?.subDropdownFilterData}
                          onClickSetDropdownFilterData={
                            props?.onClickSetSubDropdownFilterData
                          }
                        />
                      </div>
                    )) : <div className="col">
                    <div className="spinner spinner-dark spinner-lg m-auto"> </div>
                  </div>}

                  {props.isMinMaxFilter && (
                    <div
                      className="col"
                      style={{
                        maxWidth: "250px",
                        position: "relative",
                        top: "-9px",
                      }}
                    >
                      <div className="row m-0">
                        <div className="col">
                          <Field
                            name="min"
                            component={NormalInput}
                            label="Min"
                            placeholder="Min"
                            value={values.min ? values.min : ""}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="col">
                          <Field
                            name="max"
                            component={NormalInput}
                            label="Max"
                            placeholder="Max"
                            value={values.max ? values.max : ""}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                  )}

                  <>
                    {/* {props.isLogFilters && (
                    <>
                      <div className="col-lg-3 col-md-3">
                        <div
                          role="group"
                          aria-labelledby="my-radio-group"
                          className="radio-inline"
                        >
                          <label className="mr-3 col-12 p-0">
                            Delivery Status :{" "}
                          </label>
                          <label className="radio my-radio-btn">
                            <Field type="radio" name="dStatus" value={"sent"} />
                            <span></span>Sent
                          </label>
                          <label className="radio my-radio-btn">
                            <Field type="radio" name="dStatus" value={"failed"} />
                            <span></span>Failed
                          </label>
                        </div>
                      </div>
                      <div className="col-lg-2 col-md-2">
                        <CustomeSelect
                          name={"sentType"}
                          label={"Sent type"}
                          data={UIHelpers.notifySentTypeOptions}
                          placeholder="Sent type"
                          labelKey="name"
                          valueKey="_id"
                        />
                      </div>
                      <div className="col-lg-2 col-md-2">
                        <CustomeSelect
                          name={"type"}
                          label={"Content Type"}
                          data={UIHelpers.notifyTypeOptions}
                          placeholder="Content Status"
                          labelKey="name"
                          valueKey="_id"
                        />
                      </div>
                    </>
                  )}
                  {props.isTransFilter && (
                    <>
                      <div className="col-lg-2 col-md-2">
                        <CustomeSelect
                          name={"paymentType"}
                          label={"Payment Type"}
                          data={props.paymentTypeOptions}
                          placeholder="Payment Type"
                          labelKey="name"
                          valueKey="_id"
                        />
                      </div>
                      <div className="col-lg-2 col-md-2">
                        <CustomeSelect
                          name={"paymentStatus"}
                          label={"Payment Status"}
                          data={UIHelpers.paymentStatusOptions}
                          placeholder="Payment Status"
                          labelKey="name"
                          valueKey="_id"
                        />
                      </div>
                    </>
                  )}
                  {props.isConstTransFilter && (
                    <>
                      <div className="col-lg-3 col-md-3">
                        <div
                          role="group"
                          aria-labelledby="my-radio-group"
                          className="radio-inline"
                        >
                          <label className="mr-3 col-12 p-0">
                            Select Type :{" "}
                          </label>
                          <label className="radio my-radio-btn">
                            <Field
                              type="radio"
                              name="type"
                              value={"tournament"}
                            />
                            <span></span>Tournaments
                          </label>
                          <label className="radio my-radio-btn">
                            <Field type="radio" name="type" value={"contest"} />
                            <span></span>Contest
                          </label>
                        </div>
                      </div>
                      {values.type && (
                        <>
                          <div className="col-lg-2 col-md-2">
                            <Field
                              name="game"
                              component={SearchSelectInput}
                              placeholder="Game"
                              label="Games"
                              source="games"
                              displayValue="name"
                              onSelect={(item) => setCount(count + 1)}
                            />
                          </div>

                          {values.type === "tournament" && (
                            <div className="col-lg-8 col-md-8">
                              <Field
                                isShowAll={true}
                                name="event"
                                component={SearchSelectInput}
                                placeholder="Tournaments"
                                label="Tournaments"
                                source="events"
                                count={count}
                                onSelect={(item) => setCount(count + 1)}
                                filter={{ filter: { game: values.game } }}
                              />
                            </div>
                          )}

                          <div className="col-lg-8 col-md-8">
                            <Field
                              isShowAll={true}
                              name="contest"
                              component={SearchSelectInput}
                              placeholder="Contests"
                              label="Contests"
                              source="contests"
                              count={count}
                              filter={{ game: values.game, event: values.event }}
                            />
                          </div>
                        </>
                      )}
                    </>
                  )} */}
                  </>

                  <div className="justify-content-end date_range_picker_search_button_component" style={{marginLeft:'10px'}}>
                    <button
                      type="button"
                      className="btn btn-dark date_range_picker_search_button"
                      onClick={() => {
                        var send_values = values;
                        let type;

                        if (props?.mainDropdownFilterData) {
                          type = props?.mainDropdownFilterData.find(
                            (val) => val.isSelected === true
                          );
                          send_values.type =
                            type === undefined || type === null ? "" : type;
                        }

                        if (props?.subDropdownFilterData) {
                          type = props?.subDropdownFilterData.find(
                            (val) => val.isSelected === true
                          );
                          send_values.subType =
                            type === undefined || type === null ? "" : type;
                        }

                        console.log("val::22", send_values);
                        props.applyFilter(send_values);
                      }}
                    >
                      Search
                    </button>
                    {props.showExportDataTableButton && props.searchApply && (
                      <div className="" style={{ marginTop: "5px" }}>
                        <ExportDataTableButton
                          typeOfExportDataTable={props?.typeOfExportDataTable}
                          exportButtonCSVAPICall={props?.exportButtonCSVAPICall}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
          )}
        </Formik>
        <div className="col-lg-3 col-md-3 d-flex justify-content-end">
          <div className="d-flex px-4">
            {props.showDataTableDropdown && props.searchApply && (
              <div className="mx-3">
                {" "}
                {/* col-lg-7 col-md-7 */}
                <DataTableDropdown
                // label='Status'
                // dropdownFilterData={subTypeDropdownFilterData}
                // onClickSetDropdownFilterData={setSubTypeDropdownFilterData}
                />
              </div>
            )}
            {props.isColumnFilter && props.searchApply && (
              <div
                className="d-flex align-items-center"
                style={{ position: "relative", top: "3px" }}
              >
                {" "}
                {/* col-lg-2 col-md-2 */}
                <Button
                  onClick={() => setShowColumnModal(!showColumnModal)}
                  className="btn-dark"
                >
                  <i className="fa fa-columns" />
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
      {showColumnModal && (
        <ColumnsFilter
          columns={props?.columns}
          updatedCols={props?.updatedCols}
          updatedFields={props?.updatedFields}
          setShowColumnModal={setShowColumnModal}
        />
      )}
    </>
  );
};

export default DateRangeFilterComponent;
